import { render, staticRenderFns } from "./DevelopmentDetail.vue?vue&type=template&id=2439ee29"
import script from "./DevelopmentDetail.vue?vue&type=script&lang=js"
export * from "./DevelopmentDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports